/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCandidate = /* GraphQL */ `
  query GetCandidate($id: ID!) {
    getCandidate(id: $id) {
      id
      name
      email
      address
      zipCode
      city
      phoneNumber
      projectDescription
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCandidates = /* GraphQL */ `
  query ListCandidates(
    $filter: ModelCandidateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCandidates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        email
        address
        zipCode
        city
        phoneNumber
        projectDescription
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPortfolioImage = /* GraphQL */ `
  query GetPortfolioImage($id: ID!) {
    getPortfolioImage(id: $id) {
      id
      category
      s3Key
      order
      alt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPortfolioImages = /* GraphQL */ `
  query ListPortfolioImages(
    $filter: ModelPortfolioImageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPortfolioImages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        category
        s3Key
        order
        alt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
